// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"2f03e5f2","257":"9c8ba55b","629":"9614b8c1","686":"2a8b20e1","705":"57cad25a","814":"61e2dcf0"}[chunkId] + ".chunk.js";
};